/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { EditableComponent } from '@adobe/aem-react-editable-components';
import { CardCarouselResortsProps } from './CardCarouselResorts.types';
import { StyledBrandsCardsWrapper } from './CardResortsWrapper.styles';
import { CardResortsWrapper } from './CardResortsWrapper';

export const CardCarouselResortsWrapperConfig = {
  emptyLabel: 'CardCarouselResorts',
  isEmpty: false,
  resourceType: `mi-aem-brands-spa/components/content/dynamicfeaturedhotels/v1/dynamicfeaturedhotels`,
};

export const CardCarouselResortsWrapper: React.FC<CardCarouselResortsProps> = props => {
  return <CardResortsWrapper {...props} />;
};

export const CardCarouselResorts = (props: any) => {
  return !props.model.isAuthor ? (
    <StyledBrandsCardsWrapper data-testid="card-carousel-wrapper">
      <CardCarouselResortsWrapper {...props} />
    </StyledBrandsCardsWrapper>
  ) : (
    <EditableComponent config={CardCarouselResortsWrapperConfig} {...props}>
      <StyledBrandsCardsWrapper data-testid={'card-carousel-wrapper'}>
        <CardCarouselResortsWrapper {...props} />
      </StyledBrandsCardsWrapper>
    </EditableComponent>
  );
};
